import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';

@Component({
  selector: 'app-emailsent',
  templateUrl: './emailsent.component.html',
  styleUrls: ['./emailsent.component.css']
})
export class EmailsentComponent extends BaseComponent implements OnInit {

  constructor(
    private router: Router
  ) { 
    super();
    this.pageTitle = "emailSent";
  }

  ngOnInit(): void {
  }

  close() {
    this.router.navigate(['login']);
  }

}
